import { FieldHtmlNameUtil, Trans } from 'www-shared';
import UnifiedSignupScreenComponent from '../UnifiedSignupScreenComponent';
import AbstractSignupScreen from './AbstractSignupScreen';
import UnifiedSignupScreenName from '../UnifiedSignupScreenName';
import UnifiedSignupPlan from '../session-info/UnifiedSignupPlan';

export default class FreeDetail1SignupScreen extends AbstractSignupScreen {
  public readonly screenName: UnifiedSignupScreenName = 'uss-details-free-1of2';

  public getVisibleComponents(): UnifiedSignupScreenComponent[] {
    this.getField(FieldHtmlNameUtil.currentCadSystem).name = Trans.byKey('whatCadSystemAreYouMustFamiliarWith');
    return [
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.phoneNumber),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.currentCadSystem).shuffleOptionList(),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.levelOfInterestInNewCad).shuffleOptionList(),

      }),
    ];
  }

  public getValidatedComponents(): UnifiedSignupScreenComponent[] {
    return this.getVisibleComponents();
  }

  public predicate(): boolean {
    const { chosenPlan, completedDetailsScreens } = this.sessionInfo.value;
    if (chosenPlan === null || !chosenPlan.compareTo(UnifiedSignupPlan.free) || !this.isOkEmailOrPro()) {
      return false;
    }

    if (completedDetailsScreens.length !== 0) {
      return false;
    }

    return true;
  }

  public async toNextScreen(): Promise<boolean> {
    this.sessionInfo.value.completedDetailsScreens.push(this.screenName);
    return true;
  }

  // eslint-disable-next-line class-methods-use-this
  public getProgress(): number {
    return 75;
  }
}
